// Page content for all service and industry pages

export const pageContent = {
  // ===== SERVICES =====
  temporary: {
    title: {
      sk: 'Dočasné zamestnanie',
      en: 'Temporary Employment',
      de: 'Zeitarbeit'
    },
    subtitle: {
      sk: 'Flexibilné personálne riešenia pre vaše podnikanie',
      en: 'Flexible staffing solutions for your business',
      de: 'Flexible Personallösungen für Ihr Unternehmen'
    },
    description: {
      sk: `Dočasné zamestnanie je ideálne riešenie pre firmy, ktoré potrebujú rýchlo reagovať na zmeny v dopyte, sezónne výkyvy alebo krátkodobé projekty.

Ako to funguje? Pracovníci sú formálne zamestnaní u nás v WorkPro, ale pracujú priamo u vás vo firme. My sa staráme o všetku administratívu – pracovné zmluvy, mzdy, odvody do poisťovní, BOZP školenia aj pracovné odevy.

Výhody pre vašu firmu:
• Rýchle obsadenie pozícií – pracovníkov vám dodáme do 48 hodín
• Žiadne fixné náklady – platíte len za odpracované hodiny
• Flexibilita – počet pracovníkov môžete kedykoľvek upraviť
• Nulová administratívna záťaž – všetko riešime za vás
• Právna istota – preberáme zodpovednosť za zamestnancov

Tento model je vhodný pre výrobné podniky, logistické centrá, sezónne prevádzky aj projekty s definovaným trvaním.`,
      en: `Temporary employment is an ideal solution for companies that need to quickly respond to changes in demand, seasonal fluctuations, or short-term projects.

How does it work? Workers are formally employed by us at WorkPro, but they work directly at your company. We take care of all administration – employment contracts, wages, insurance contributions, safety training, and work clothing.

Benefits for your company:
• Fast position filling – we deliver workers within 48 hours
• No fixed costs – you only pay for hours worked
• Flexibility – you can adjust the number of workers at any time
• Zero administrative burden – we handle everything for you
• Legal certainty – we take responsibility for employees

This model is suitable for manufacturing companies, logistics centers, seasonal operations, and projects with a defined duration.`,
      de: `Zeitarbeit ist eine ideale Lösung für Unternehmen, die schnell auf Nachfrageänderungen, saisonale Schwankungen oder kurzfristige Projekte reagieren müssen.

Wie funktioniert es? Die Arbeitnehmer sind formal bei uns bei WorkPro angestellt, arbeiten aber direkt in Ihrem Unternehmen. Wir kümmern uns um die gesamte Verwaltung – Arbeitsverträge, Löhne, Versicherungsbeiträge, Sicherheitsschulungen und Arbeitskleidung.

Vorteile für Ihr Unternehmen:
• Schnelle Stellenbesetzung – wir liefern Arbeitskräfte innerhalb von 48 Stunden
• Keine Fixkosten – Sie zahlen nur für geleistete Stunden
• Flexibilität – Sie können die Anzahl der Arbeitskräfte jederzeit anpassen
• Null Verwaltungsaufwand – wir erledigen alles für Sie
• Rechtssicherheit – wir übernehmen die Verantwortung für Mitarbeiter

Dieses Modell eignet sich für Fertigungsunternehmen, Logistikzentren, Saisonbetriebe und Projekte mit definierter Laufzeit.`
    },
    benefits: {
      sk: [
        { title: 'Rýchle obsadenie do 48h', description: 'Máme rozsiahlu databázu overených kandidátov pripravených nastúpiť okamžite. Urgentné požiadavky riešime aj do 24 hodín.' },
        { title: 'Kompletná administratíva', description: 'Pracovné zmluvy, mzdová agenda, odvody, daňové priznania, evidencia dochádzky – o všetko sa postaráme my.' },
        { title: 'Flexibilné navyšovanie a znižovanie', description: 'Potrebujete viac ľudí na sezónu? Alebo naopak znížiť stavy? Reagujeme do 24 hodín bez akýchkoľvek sankcií.' },
        { title: 'BOZP a pracovné odevy', description: 'Zabezpečíme vstupné školenia, pravidelné preškolenia, pracovné odevy aj osobné ochranné pomôcky.' },
        { title: 'Právna zodpovednosť', description: 'Ako zamestnávateľ preberáme plnú právnu zodpovednosť. V prípade kontroly inšpekcie práce vás zastúpime.' },
        { title: 'Transparentné účtovanie', description: 'Jasná hodinová sadzba bez skrytých poplatkov. Faktúry s detailným rozpisom odpracovaných hodín.' }
      ],
      en: [
        { title: 'Fast placement within 48h', description: 'We have an extensive database of verified candidates ready to start immediately. We handle urgent requests within 24 hours.' },
        { title: 'Complete administration', description: 'Employment contracts, payroll, taxes, tax returns, attendance tracking – we take care of everything.' },
        { title: 'Flexible scaling up and down', description: 'Need more people for the season? Or reduce staff? We respond within 24 hours without any penalties.' },
        { title: 'Safety and work clothing', description: 'We provide initial training, regular retraining, work clothing, and personal protective equipment.' },
        { title: 'Legal responsibility', description: 'As the employer, we assume full legal responsibility. In case of labor inspection, we represent you.' },
        { title: 'Transparent billing', description: 'Clear hourly rate with no hidden fees. Invoices with detailed breakdown of hours worked.' }
      ],
      de: [
        { title: 'Schnelle Besetzung in 48h', description: 'Wir haben eine umfangreiche Datenbank verifizierter Kandidaten, die sofort einsatzbereit sind. Dringende Anfragen bearbeiten wir innerhalb von 24 Stunden.' },
        { title: 'Komplette Verwaltung', description: 'Arbeitsverträge, Lohnbuchhaltung, Steuern, Steuererklärungen, Anwesenheitsverfolgung – wir kümmern uns um alles.' },
        { title: 'Flexibles Auf- und Abskalieren', description: 'Brauchen Sie mehr Leute für die Saison? Oder Personal reduzieren? Wir reagieren innerhalb von 24 Stunden ohne Strafen.' },
        { title: 'Sicherheit und Arbeitskleidung', description: 'Wir bieten Erstschulungen, regelmäßige Nachschulungen, Arbeitskleidung und persönliche Schutzausrüstung.' },
        { title: 'Rechtliche Verantwortung', description: 'Als Arbeitgeber übernehmen wir die volle rechtliche Verantwortung. Bei Arbeitsinspektion vertreten wir Sie.' },
        { title: 'Transparente Abrechnung', description: 'Klarer Stundensatz ohne versteckte Gebühren. Rechnungen mit detaillierter Aufschlüsselung der geleisteten Stunden.' }
      ]
    },
    positions: {
      sk: ['Operátori výroby', 'Skladníci', 'Montážnici', 'Baliari', 'Pomocní pracovníci', 'Vodiči VZV', 'Kontrolóri kvality', 'Čističi', 'Manipulanti', 'Sezónni pracovníci'],
      en: ['Production operators', 'Warehouse workers', 'Assemblers', 'Packers', 'General workers', 'Forklift drivers', 'Quality inspectors', 'Cleaners', 'Material handlers', 'Seasonal workers'],
      de: ['Produktionsmitarbeiter', 'Lagerarbeiter', 'Monteure', 'Verpacker', 'Hilfsarbeiter', 'Gabelstaplerfahrer', 'Qualitätsprüfer', 'Reinigungskräfte', 'Materialhandler', 'Saisonarbeiter']
    }
  },

  recruitment: {
    title: {
      sk: 'Recruitment',
      en: 'Recruitment',
      de: 'Rekrutierung'
    },
    subtitle: {
      sk: 'Profesionálne vyhľadávanie a výber zamestnancov',
      en: 'Professional employee search and selection',
      de: 'Professionelle Mitarbeitersuche und -auswahl'
    },
    description: {
      sk: `Hľadáte kvalifikovaných zamestnancov do trvalého pracovného pomeru? Náš recruitment tím vám pomôže nájsť tých najlepších kandidátov na trhu.

Náš proces:
1. Analýza pozície – stretnutie s vami, pochopenie požiadaviek a firemnej kultúry
2. Vyhľadávanie kandidátov – aktívne oslovujeme pasívnych kandidátov, využívame databázu 50,000+ kontaktov, inzerujeme na pracovných portáloch
3. Predvýber – telefonické rozhovory, overenie referencií, testovanie zručností
4. Prezentácia kandidátov – dodáme vám 3-5 najlepších kandidátov s kompletnými profilmi
5. Podpora pri výbere – asistujeme pri pohovoroch, pomáhame s vyjednávaním podmienok

Špecializujeme sa na pozície v oblastiach: výroba, logistika, administratíva, IT, obchod a stredný manažment.

Garancia: Ak kandidát odíde v skúšobnej dobe, nájdeme náhradu zadarmo.`,
      en: `Looking for qualified employees for permanent positions? Our recruitment team will help you find the best candidates on the market.

Our process:
1. Position analysis – meeting with you, understanding requirements and company culture
2. Candidate sourcing – we actively approach passive candidates, use a database of 50,000+ contacts, advertise on job portals
3. Pre-selection – phone interviews, reference checking, skills testing
4. Candidate presentation – we deliver 3-5 best candidates with complete profiles
5. Selection support – we assist with interviews, help with negotiating terms

We specialize in positions in: manufacturing, logistics, administration, IT, sales, and middle management.

Guarantee: If the candidate leaves during probation, we find a replacement for free.`,
      de: `Suchen Sie qualifizierte Mitarbeiter für Festanstellungen? Unser Rekrutierungsteam hilft Ihnen, die besten Kandidaten auf dem Markt zu finden.

Unser Prozess:
1. Stellenanalyse – Treffen mit Ihnen, Verständnis der Anforderungen und Unternehmenskultur
2. Kandidatensuche – wir sprechen aktiv passive Kandidaten an, nutzen eine Datenbank mit 50.000+ Kontakten, inserieren auf Jobportalen
3. Vorauswahl – Telefoninterviews, Referenzprüfung, Kompetenztest
4. Kandidatenpräsentation – wir liefern 3-5 beste Kandidaten mit vollständigen Profilen
5. Auswahlunterstützung – wir helfen bei Interviews, unterstützen bei Verhandlungen

Wir sind spezialisiert auf Positionen in: Fertigung, Logistik, Verwaltung, IT, Vertrieb und mittleres Management.

Garantie: Wenn der Kandidat während der Probezeit ausscheidet, finden wir kostenlos Ersatz.`
    },
    benefits: {
      sk: [
        { title: 'Rozsiahla databáza 50,000+ kandidátov', description: 'Roky budujeme sieť kontaktov v rôznych odvetviach. Máme prístup aj ku kandidátom, ktorí aktívne nehľadajú prácu.' },
        { title: 'Aktívny headhunting', description: 'Nebudeme čakať na reakcie na inzerát. Aktívne oslovujeme top talenty cez LinkedIn, odborné komunity a naše kontakty.' },
        { title: 'Dôkladný predvýber', description: 'Každý kandidát prejde telefonickým pohovorom, overením referencií a testovaním. Vy dostanete len tých najlepších.' },
        { title: 'Garancia v skúšobnej dobe', description: 'Ak kandidát odíde alebo nesplní očakávania v skúšobnej dobe, nájdeme náhradu bez ďalších poplatkov.' },
        { title: 'Úspora vášho času', description: 'Nemusíte triediť stovky životopisov. Prezentujeme vám 3-5 najvhodnejších kandidátov pripravených na finálny pohovor.' },
        { title: 'Odborné poradenstvo', description: 'Poradíme vám s nastavením konkurencieschopných podmienok a pomôžeme s onboardingom nového zamestnanca.' }
      ],
      en: [
        { title: 'Extensive database of 50,000+ candidates', description: 'We have been building a network of contacts in various industries for years. We have access to candidates who are not actively looking for work.' },
        { title: 'Active headhunting', description: 'We won\'t wait for responses to ads. We actively approach top talents via LinkedIn, professional communities, and our contacts.' },
        { title: 'Thorough pre-selection', description: 'Every candidate goes through a phone interview, reference checking, and testing. You only get the best ones.' },
        { title: 'Probation period guarantee', description: 'If the candidate leaves or fails to meet expectations during probation, we find a replacement at no additional cost.' },
        { title: 'Save your time', description: 'You don\'t have to sort through hundreds of CVs. We present you with 3-5 most suitable candidates ready for final interview.' },
        { title: 'Expert advice', description: 'We advise you on setting competitive conditions and help with onboarding the new employee.' }
      ],
      de: [
        { title: 'Umfangreiche Datenbank mit 50.000+ Kandidaten', description: 'Wir bauen seit Jahren ein Kontaktnetzwerk in verschiedenen Branchen auf. Wir haben Zugang zu Kandidaten, die nicht aktiv nach Arbeit suchen.' },
        { title: 'Aktives Headhunting', description: 'Wir warten nicht auf Reaktionen auf Anzeigen. Wir sprechen Top-Talente aktiv über LinkedIn, Fachgemeinschaften und unsere Kontakte an.' },
        { title: 'Gründliche Vorauswahl', description: 'Jeder Kandidat durchläuft ein Telefoninterview, Referenzprüfung und Tests. Sie bekommen nur die Besten.' },
        { title: 'Probezeit-Garantie', description: 'Wenn der Kandidat ausscheidet oder die Erwartungen nicht erfüllt, finden wir kostenlos Ersatz.' },
        { title: 'Sparen Sie Ihre Zeit', description: 'Sie müssen nicht Hunderte von Lebensläufen durchsehen. Wir präsentieren Ihnen 3-5 geeignetste Kandidaten.' },
        { title: 'Expertenberatung', description: 'Wir beraten Sie bei wettbewerbsfähigen Konditionen und helfen beim Onboarding des neuen Mitarbeiters.' }
      ]
    },
    positions: {
      sk: ['Manažéri', 'Team leaderi', 'Špecialisti', 'IT pozície', 'Obchodníci', 'Účtovníci', 'HR špecialisti', 'Technici', 'Inžinieri', 'Administratíva'],
      en: ['Managers', 'Team leaders', 'Specialists', 'IT positions', 'Sales', 'Accountants', 'HR specialists', 'Technicians', 'Engineers', 'Administration'],
      de: ['Manager', 'Teamleiter', 'Spezialisten', 'IT-Positionen', 'Vertrieb', 'Buchhalter', 'HR-Spezialisten', 'Techniker', 'Ingenieure', 'Verwaltung']
    }
  },

  consulting: {
    title: {
      sk: 'HR poradenstvo',
      en: 'HR Consulting',
      de: 'HR-Beratung'
    },
    subtitle: {
      sk: 'Strategické poradenstvo v oblasti ľudských zdrojov',
      en: 'Strategic human resources consulting',
      de: 'Strategische Personalberatung'
    },
    description: {
      sk: `Máte problémy s fluktuáciou? Neviete, ako nastaviť systém odmeňovania? Potrebujete posilniť svoju značku zamestnávateľa?

Naši HR konzultanti majú desiatky rokov skúseností z rôznych odvetví. Pomôžeme vám:

• Znížiť fluktuáciu – analyzujeme príčiny odchodov a navrhneme konkrétne opatrenia
• Nastaviť odmeňovanie – vytvoríme motivačný systém, ktorý priláka a udrží talenty
• Zlepšiť nábor – optimalizujeme vaše náborové procesy a employer branding
• Rozvíjať zamestnancov – navrhneme programy vzdelávania a kariérneho rastu
• Zvládnuť zmeny – pomôžeme s reštrukturalizáciou, zlučovaním tímov či zmenami vo vedení

Pracujeme projektovo aj formou dlhodobého partnerstva. Prvá konzultácia je nezáväzná a zadarmo.`,
      en: `Having problems with turnover? Don't know how to set up a compensation system? Need to strengthen your employer brand?

Our HR consultants have decades of experience from various industries. We will help you:

• Reduce turnover – we analyze the causes of departures and propose specific measures
• Set up compensation – we create a motivational system that attracts and retains talents
• Improve recruitment – we optimize your recruitment processes and employer branding
• Develop employees – we design training and career growth programs
• Manage changes – we help with restructuring, merging teams, or leadership changes

We work on a project basis or as a long-term partnership. The first consultation is non-binding and free.`,
      de: `Haben Sie Probleme mit der Fluktuation? Wissen Sie nicht, wie Sie ein Vergütungssystem einrichten sollen? Müssen Sie Ihre Arbeitgebermarke stärken?

Unsere HR-Berater haben jahrzehntelange Erfahrung aus verschiedenen Branchen. Wir helfen Ihnen:

• Fluktuation reduzieren – wir analysieren die Ursachen von Abgängen und schlagen konkrete Maßnahmen vor
• Vergütung einrichten – wir erstellen ein motivierendes System, das Talente anzieht und hält
• Rekrutierung verbessern – wir optimieren Ihre Rekrutierungsprozesse und Employer Branding
• Mitarbeiter entwickeln – wir entwerfen Schulungs- und Karriereentwicklungsprogramme
• Veränderungen managen – wir helfen bei Umstrukturierungen, Teamzusammenlegungen oder Führungswechseln

Wir arbeiten projektbasiert oder in langfristiger Partnerschaft. Die erste Beratung ist unverbindlich und kostenlos.`
    },
    benefits: {
      sk: [
        { title: 'HR audit a analýza', description: 'Komplexne zanalyzujeme vaše HR procesy, identifikujeme slabé miesta a navrhneme konkrétne zlepšenia s merateľnými výsledkami.' },
        { title: 'Systém odmeňovania a benefitov', description: 'Vytvoríme transparentný a motivačný systém miezd, prémií a benefitov. Porovnáme vás s trhom a nastavíme konkurencieschopné podmienky.' },
        { title: 'Employer branding', description: 'Posilníme vašu značku zamestnávateľa. Kariérne stránky, firemná kultúra, EVP (Employee Value Proposition) – všetko na jednom mieste.' },
        { title: 'Vzdelávanie a rozvoj', description: 'Navrhneme program rozvoja zamestnancov – od onboardingu, cez soft skills tréningy až po leadership programy pre manažérov.' },
        { title: 'Outplacement', description: 'Pomôžeme vašim zamestnancom pri odchode – kariérne poradenstvo, príprava životopisov, nácvik pohovorov.' },
        { title: 'HR interim manažment', description: 'Potrebujete dočasne obsadiť pozíciu HR manažéra? Poskytneme vám skúseného HR profesionála na prechodné obdobie.' }
      ],
      en: [
        { title: 'HR audit and analysis', description: 'We comprehensively analyze your HR processes, identify weaknesses, and propose specific improvements with measurable results.' },
        { title: 'Compensation and benefits system', description: 'We create a transparent and motivating system of wages, bonuses, and benefits. We compare you with the market and set competitive conditions.' },
        { title: 'Employer branding', description: 'We strengthen your employer brand. Career pages, company culture, EVP (Employee Value Proposition) – all in one place.' },
        { title: 'Training and development', description: 'We design employee development programs – from onboarding, through soft skills training, to leadership programs for managers.' },
        { title: 'Outplacement', description: 'We help your employees when leaving – career counseling, CV preparation, interview practice.' },
        { title: 'HR interim management', description: 'Need to temporarily fill an HR manager position? We provide an experienced HR professional for the transition period.' }
      ],
      de: [
        { title: 'HR-Audit und Analyse', description: 'Wir analysieren umfassend Ihre HR-Prozesse, identifizieren Schwachstellen und schlagen konkrete Verbesserungen mit messbaren Ergebnissen vor.' },
        { title: 'Vergütungs- und Benefitsystem', description: 'Wir erstellen ein transparentes und motivierendes System von Gehältern, Prämien und Benefits. Wir vergleichen Sie mit dem Markt.' },
        { title: 'Employer Branding', description: 'Wir stärken Ihre Arbeitgebermarke. Karriereseiten, Unternehmenskultur, EVP (Employee Value Proposition) – alles an einem Ort.' },
        { title: 'Schulung und Entwicklung', description: 'Wir entwerfen Mitarbeiterentwicklungsprogramme – vom Onboarding über Soft-Skills-Training bis zu Leadership-Programmen.' },
        { title: 'Outplacement', description: 'Wir helfen Ihren Mitarbeitern beim Ausscheiden – Karriereberatung, Lebenslaufvorbereitung, Interviewtraining.' },
        { title: 'HR Interim Management', description: 'Müssen Sie vorübergehend eine HR-Manager-Position besetzen? Wir stellen einen erfahrenen HR-Profi für die Übergangszeit.' }
      ]
    },
    positions: {
      sk: [],
      en: [],
      de: []
    }
  },

  // ===== INDUSTRIES =====
  manufacturing: {
    title: {
      sk: 'Výrobné podniky',
      en: 'Manufacturing',
      de: 'Produktion'
    },
    subtitle: {
      sk: 'Personálne riešenia pre výrobný priemysel',
      en: 'Staffing solutions for manufacturing industry',
      de: 'Personallösungen für die Fertigungsindustrie'
    },
    description: {
      sk: 'Špecializujeme sa na obsadzovanie pozícií vo výrobných podnikoch. Rozumieme špecifikám trojzmennej prevádzky, požiadavkám na kvalitu a bezpečnosť práce. Dodávame pracovníkov pre automobilový priemysel, strojárstvo, elektrotechniku a ďalšie odvetvia.',
      en: 'We specialize in filling positions in manufacturing companies. We understand the specifics of three-shift operation, quality requirements, and workplace safety. We supply workers for the automotive industry, mechanical engineering, electronics, and other sectors.',
      de: 'Wir sind spezialisiert auf die Besetzung von Positionen in Fertigungsunternehmen. Wir verstehen die Besonderheiten des Dreischichtbetriebs, Qualitätsanforderungen und Arbeitssicherheit. Wir liefern Arbeitskräfte für die Automobilindustrie, den Maschinenbau, die Elektronik und andere Sektoren.'
    },
    benefits: {
      sk: [
        { title: 'Skúsenosti s výrobou', description: 'Dlhoročné skúsenosti s obsadzovaním výrobných pozícií.' },
        { title: 'Trojzmenná prevádzka', description: 'Dodávame pracovníkov pre všetky zmeny.' },
        { title: 'Technické pozície', description: 'Máme databázu kvalifikovaných technických pracovníkov.' },
        { title: 'Sezónne výkyvy', description: 'Pomôžeme vám zvládnuť nárazové zvýšenie výroby.' }
      ],
      en: [
        { title: 'Manufacturing experience', description: 'Years of experience filling manufacturing positions.' },
        { title: 'Three-shift operation', description: 'We supply workers for all shifts.' },
        { title: 'Technical positions', description: 'We have a database of qualified technical workers.' },
        { title: 'Seasonal fluctuations', description: 'We help you handle production spikes.' }
      ],
      de: [
        { title: 'Fertigungserfahrung', description: 'Langjährige Erfahrung bei der Besetzung von Fertigungspositionen.' },
        { title: 'Dreischichtbetrieb', description: 'Wir liefern Arbeitskräfte für alle Schichten.' },
        { title: 'Technische Positionen', description: 'Wir haben eine Datenbank qualifizierter technischer Arbeitskräfte.' },
        { title: 'Saisonale Schwankungen', description: 'Wir helfen Ihnen, Produktionsspitzen zu bewältigen.' }
      ]
    },
    positions: {
      sk: ['Operátori CNC', 'Zvárači', 'Montážnici', 'Brúsiči', 'Strojári', 'Lakovníci', 'Kontrolóri kvality', 'Obsluha strojov'],
      en: ['CNC operators', 'Welders', 'Assemblers', 'Grinders', 'Machinists', 'Painters', 'Quality inspectors', 'Machine operators'],
      de: ['CNC-Bediener', 'Schweißer', 'Monteure', 'Schleifer', 'Maschinisten', 'Lackierer', 'Qualitätsprüfer', 'Maschinenbediener']
    }
  },

  logistics: {
    title: {
      sk: 'Logistika',
      en: 'Logistics',
      de: 'Logistik'
    },
    subtitle: {
      sk: 'Personálne riešenia pre logistiku a sklady',
      en: 'Staffing solutions for logistics and warehouses',
      de: 'Personallösungen für Logistik und Lager'
    },
    description: {
      sk: 'Logistické centrá a sklady potrebujú spoľahlivých pracovníkov, ktorí zvládnu fyzicky náročnú prácu. Dodávame skladníkov, vodičov VZV, baliačov a ďalších pracovníkov pre e-commerce, distribučné centrá a logistické spoločnosti.',
      en: 'Logistics centers and warehouses need reliable workers who can handle physically demanding work. We supply warehouse workers, forklift drivers, packers, and other workers for e-commerce, distribution centers, and logistics companies.',
      de: 'Logistikzentren und Lager benötigen zuverlässige Arbeitskräfte, die körperlich anspruchsvolle Arbeit bewältigen können. Wir liefern Lagerarbeiter, Gabelstaplerfahrer, Verpacker und andere Arbeitskräfte für E-Commerce, Verteilzentren und Logistikunternehmen.'
    },
    benefits: {
      sk: [
        { title: 'Vodiči VZV', description: 'Máme databázu vodičov s platným preukazom VZV.' },
        { title: 'Sezónna flexibilita', description: 'Zvýšime kapacity počas sezónnych špičiek.' },
        { title: 'Nočné zmeny', description: 'Dodávame pracovníkov aj na nočné zmeny.' },
        { title: 'E-commerce skúsenosti', description: 'Pracovníci so skúsenosťami z fulfillment centier.' }
      ],
      en: [
        { title: 'Forklift drivers', description: 'We have a database of drivers with valid forklift licenses.' },
        { title: 'Seasonal flexibility', description: 'We increase capacity during seasonal peaks.' },
        { title: 'Night shifts', description: 'We supply workers for night shifts as well.' },
        { title: 'E-commerce experience', description: 'Workers with experience from fulfillment centers.' }
      ],
      de: [
        { title: 'Gabelstaplerfahrer', description: 'Wir haben eine Datenbank von Fahrern mit gültigen Gabelstaplerführerscheinen.' },
        { title: 'Saisonale Flexibilität', description: 'Wir erhöhen die Kapazität während saisonaler Spitzen.' },
        { title: 'Nachtschichten', description: 'Wir liefern auch Arbeitskräfte für Nachtschichten.' },
        { title: 'E-Commerce-Erfahrung', description: 'Arbeitskräfte mit Erfahrung aus Fulfillment-Zentren.' }
      ]
    },
    positions: {
      sk: ['Skladníci', 'Vodiči VZV', 'Baliari', 'Picker/Packer', 'Vodiči', 'Dispečeri', 'Vedúci skladu'],
      en: ['Warehouse workers', 'Forklift drivers', 'Packers', 'Picker/Packer', 'Drivers', 'Dispatchers', 'Warehouse managers'],
      de: ['Lagerarbeiter', 'Gabelstaplerfahrer', 'Verpacker', 'Picker/Packer', 'Fahrer', 'Disponenten', 'Lagerleiter']
    }
  },

  it: {
    title: {
      sk: 'IT sektor',
      en: 'IT Sector',
      de: 'IT-Sektor'
    },
    subtitle: {
      sk: 'IT špecialisti pre vaše projekty',
      en: 'IT specialists for your projects',
      de: 'IT-Spezialisten für Ihre Projekte'
    },
    description: {
      sk: 'Hľadáte IT špecialistov? Pomôžeme vám nájsť developerov, testerov, administrátorov a ďalších IT profesionálov. Ponúkame dočasné aj trvalé umiestnenie, kontraktovanie aj body shopping.',
      en: 'Looking for IT specialists? We will help you find developers, testers, administrators, and other IT professionals. We offer temporary and permanent placement, contracting, and body shopping.',
      de: 'Suchen Sie IT-Spezialisten? Wir helfen Ihnen, Entwickler, Tester, Administratoren und andere IT-Fachleute zu finden. Wir bieten temporäre und permanente Vermittlung, Contracting und Body Shopping.'
    },
    benefits: {
      sk: [
        { title: 'IT databáza', description: 'Máme špecializovanú databázu IT profesionálov.' },
        { title: 'Technické pohovory', description: 'Vykonávame technický prescreening kandidátov.' },
        { title: 'Flexibilné modely', description: 'Time & Material, Fixed Price, Body Shopping.' },
        { title: 'Remote pracovníci', description: 'Dokážeme zabezpečiť aj remote IT tímy.' }
      ],
      en: [
        { title: 'IT database', description: 'We have a specialized database of IT professionals.' },
        { title: 'Technical interviews', description: 'We conduct technical pre-screening of candidates.' },
        { title: 'Flexible models', description: 'Time & Material, Fixed Price, Body Shopping.' },
        { title: 'Remote workers', description: 'We can also provide remote IT teams.' }
      ],
      de: [
        { title: 'IT-Datenbank', description: 'Wir haben eine spezialisierte Datenbank von IT-Fachleuten.' },
        { title: 'Technische Interviews', description: 'Wir führen technisches Pre-Screening von Kandidaten durch.' },
        { title: 'Flexible Modelle', description: 'Time & Material, Fixed Price, Body Shopping.' },
        { title: 'Remote-Mitarbeiter', description: 'Wir können auch Remote-IT-Teams bereitstellen.' }
      ]
    },
    positions: {
      sk: ['Developeri', 'Testeri', 'DevOps', 'Systémoví administrátori', 'IT support', 'Projektoví manažéri', 'Business analytici'],
      en: ['Developers', 'Testers', 'DevOps', 'System administrators', 'IT support', 'Project managers', 'Business analysts'],
      de: ['Entwickler', 'Tester', 'DevOps', 'Systemadministratoren', 'IT-Support', 'Projektmanager', 'Business Analysten']
    }
  },

  retail: {
    title: {
      sk: 'Retail',
      en: 'Retail',
      de: 'Einzelhandel'
    },
    subtitle: {
      sk: 'Personálne riešenia pre maloobchod',
      en: 'Staffing solutions for retail',
      de: 'Personallösungen für den Einzelhandel'
    },
    description: {
      sk: 'Retail sektor vyžaduje flexibilných pracovníkov, ktorí dokážu pracovať s ľuďmi. Dodávame predavačov, pokladníkov, merchandiserov a ďalších pracovníkov pre obchodné reťazce, špecializované predajne aj sezónne projekty.',
      en: 'The retail sector requires flexible workers who can work with people. We supply salespeople, cashiers, merchandisers, and other workers for retail chains, specialty stores, and seasonal projects.',
      de: 'Der Einzelhandelssektor erfordert flexible Arbeitskräfte, die mit Menschen arbeiten können. Wir liefern Verkäufer, Kassierer, Merchandiser und andere Arbeitskräfte für Einzelhandelsketten, Fachgeschäfte und saisonale Projekte.'
    },
    benefits: {
      sk: [
        { title: 'Zákaznícky servis', description: 'Pracovníci so skúsenosťami v práci so zákazníkmi.' },
        { title: 'Sezónne posilnenie', description: 'Vianoce, výpredaje - pomôžeme vám zvládnuť nápor.' },
        { title: 'Flexibilné úväzky', description: 'Plný úväzok, polovičný aj brigádnici.' },
        { title: 'Inventúry', description: 'Špeciálne tímy pre inventarizáciu.' }
      ],
      en: [
        { title: 'Customer service', description: 'Workers with experience in customer work.' },
        { title: 'Seasonal reinforcement', description: 'Christmas, sales - we help you handle the rush.' },
        { title: 'Flexible contracts', description: 'Full-time, part-time, and temporary workers.' },
        { title: 'Inventories', description: 'Special teams for inventory.' }
      ],
      de: [
        { title: 'Kundenservice', description: 'Arbeitskräfte mit Erfahrung in der Kundenarbeit.' },
        { title: 'Saisonale Verstärkung', description: 'Weihnachten, Verkäufe - wir helfen Ihnen, den Ansturm zu bewältigen.' },
        { title: 'Flexible Verträge', description: 'Vollzeit, Teilzeit und Zeitarbeiter.' },
        { title: 'Inventuren', description: 'Spezialteams für Inventur.' }
      ]
    },
    positions: {
      sk: ['Predavači', 'Pokladníci', 'Merchandiseri', 'Vedúci predajne', 'Inventuristi', 'Promotéri'],
      en: ['Salespeople', 'Cashiers', 'Merchandisers', 'Store managers', 'Inventory workers', 'Promoters'],
      de: ['Verkäufer', 'Kassierer', 'Merchandiser', 'Filialleiter', 'Inventurarbeiter', 'Promoter']
    }
  }
};
